module.exports = __webpack_public_path__ + "static/media/2.f6249d1b.svg";